"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment, useSubscription } from "@opensea/graphql";
import { cloneDeep, set } from "es-toolkit/compat";
import { useState } from "react";
const UseLiveUpdateItemsBestOrdersSubscription = graphql(`
  subscription UseLiveUpdateItemsBestOrdersSubscription(
    $identifiers: [ItemIdentifierInput!]!
  ) {
    itemsByIdentifiers(identifiers: $identifiers) {
      id
      collection {
        id
        floorPrice {
          id
          pricePerItem {
            token {
              unit
            }
          }
        }
      }
      bestOffer {
        id
        pricePerItem {
          token {
            unit
          }
        }
      }
      bestListing {
        pricePerItem {
          token {
            unit
          }
        }
      }
    }
  }
`);
export const useLiveUpdateItemsBestOrdersFragment = graphql(`
  fragment useLiveUpdateItemsBestOrders on Item {
    id
    tokenId
    contractAddress
    chain {
      identifier
    }
  }
`);
export function useLiveUpdateItemsBestOrders(initialItems) {
  const $ = _c(5);
  const [items, setItems] = useState(initialItems);
  let t0;
  if ($[0] !== initialItems) {
    t0 = initialItems.map(_temp).map(_temp2);
    $[0] = initialItems;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      query: UseLiveUpdateItemsBestOrdersSubscription,
      variables: {
        identifiers: t0
      }
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      onResult: updateData => {
        if (updateData?.itemsByIdentifiers) {
          setItems(prevItems => prevItems.map(prevItem => {
            const itemId = readFragment(useLiveUpdateItemsBestOrdersFragment, prevItem).id;
            if (itemId !== updateData.itemsByIdentifiers.id) {
              return prevItem;
            }
            const item_0 = cloneDeep(prevItem);
            set(item_0, "collection.floorPrice.pricePerItem.token.unit", updateData.itemsByIdentifiers.collection?.floorPrice?.pricePerItem.token.unit);
            set(item_0, "bestOffer.pricePerItem.token.unit", updateData.itemsByIdentifiers.bestOffer?.pricePerItem.token.unit);
            set(item_0, "bestListing.pricePerItem.token.unit", updateData.itemsByIdentifiers.bestListing?.pricePerItem.token.unit);
            return item_0;
          }));
        }
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useSubscription(t1, t2);
  return items;
}
function _temp2(item) {
  return {
    tokenId: item.tokenId,
    contractAddress: item.contractAddress,
    chain: item.chain.identifier
  };
}
function _temp(itemKey) {
  return readFragment(useLiveUpdateItemsBestOrdersFragment, itemKey);
}